import { ContentBox } from "@msuite/ui/content-box";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { getAtomicNumberString } from "@msuite/utils/organizations";
import { guardString } from "@msuite/utils/strings";
import { useParams } from "react-router";
import { useService } from "@/hooks/use-service";
import { ServiceFulfillmentPartners } from "./service-fulfillment-partners";
import { ServiceGeneral } from "./service-general";
import { ServiceMenu } from "./service-menu";
import { ServiceSettings } from "./service-settings";

export function Service() {
	const { serviceId } = useParams();

	/** Hooks */
	const { t } = useTranslation();
	const { service } = useService(serviceId);

	if (!serviceId) {
		return <div>Service ID is missing</div>;
	}

	/** Render */
	return (
		<ContentBox>
			<ContentCard
				title={getAtomicNumberString(guardString(service?.fullNumber))}
				icon={icon("Hash")}
				identifier={service ? serviceId : undefined}
			>
				<p>{guardString(service?.shortText)}</p>
			</ContentCard>
			<Tabs
				panelKey="service-details-tabs"
				groups={[
					{
						name: "general",
						panels: [
							{
								label: t("general.general"),
								panel: () => <ServiceGeneral serviceId={serviceId} />,
								cyId: "service-general-tab",
								errors: [],
							},
						],
					},
					{
						name: "details",
						panels: [
							service?.fulfillmentType === "external"
								? {
										label: t("organization.data.fulfillment_partners"),
										panel: () => <ServiceFulfillmentPartners serviceId={serviceId} />,
										cyId: "service-fulfillment-partners-tab",
										errors: [],
									}
								: null,
						],
					},
					"spacer",
					{
						name: "settings",
						panels: [
							{
								label: t("general.settings"),
								panel: () => <ServiceSettings serviceId={serviceId} />,
								cyId: "service-settings-tab",
								errors: [],
							},
						],
					},
				]}
				header={() => <ServiceMenu serviceId={serviceId} />}
			/>
		</ContentBox>
	);
}
